import { createAsyncThunk } from '@reduxjs/toolkit';
import { ErrorToast, SuccessToast } from '../../components';
import axios from 'axios';
import { Dispatch, SetStateAction } from 'react';

interface SendSecurityCodeType {
  signInToken: string;
  setIsCodeSent: Dispatch<SetStateAction<boolean>>;
}

export const sendSecurityCode = createAsyncThunk(
  'auth/addEmailToNewTeamMember',
  async (
    { signInToken, setIsCodeSent }: SendSecurityCodeType,
    { rejectWithValue }
  ) => {
    try {
      await axios.post(`/authorization/signin/email/code`, {
        signInToken
      });

      SuccessToast('Code sent successfully');
      setIsCodeSent(true);
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
